import { getFileTypeForMimeType } from "utils/files.js";

export default angular.module("vesl.filters.formatFileType", [])
	.filter("formatFileType", function() {
		return (mimeType) => getFileTypeForMimeType(mimeType).name;
	})
	.name;
